import styled from '@emotion/styled'
import { FillProperty } from 'csstype'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export interface CameraProps {
    className?: string
    width?: number
    height?: number
    horizontalSpacing?: number | undefined
    fill?: FillProperty
}

export const StyledCameraIcon = styled('svg')<CameraProps>((props) => ({
    width: props.width ? calcRem(props.width) : undefined,
    height: props.height ? calcRem(props.height) : undefined,
    marginLeft: props.horizontalSpacing && calcRem(props.horizontalSpacing),
    fill: props.fill as FillProperty,
}))
